
export type GetHashtags200DataItem = {
  id?: string;
  name?: string;
  tweetCount?: number;
};
